import React, { useEffect, useState } from 'react';
import { Select, Table, Button, Space, message, Popconfirm, Card } from 'antd';
import { fetchAllowedDevices, addAllowedDevice, removeAllowedDevice, fetchDevices } from '../../api';
import { fetchUsers } from '../../../permissionSet/api';

const reportResult = (res, okMsg) => {
  if (res?.pendingApproval) message.info('Submitted for approval — takes effect once approved.');
  else message.success(okMsg);
};

// Assigns specific registered devices to an employee (for SPECIFIC_DEVICES policy).
const DeviceAssignmentTab = () => {
  const [users, setUsers] = useState([]);
  const [devices, setDevices] = useState([]);
  const [employeeId, setEmployeeId] = useState(null);
  const [allowed, setAllowed] = useState([]);
  const [deviceToAdd, setDeviceToAdd] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchUsers({ limit: 200 }).then((r) => setUsers(r.data || [])).catch(() => {});
    fetchDevices({ status: 'ACTIVE' }).then((r) => setDevices(r.data || [])).catch(() => {});
  }, []);

  const loadAllowed = async (empId) => {
    if (!empId) return;
    setLoading(true);
    try { setAllowed((await fetchAllowedDevices(empId)).data || []); }
    catch { message.error('Failed to load allowed devices'); }
    finally { setLoading(false); }
  };

  const onSelectEmployee = (val) => { setEmployeeId(val); loadAllowed(val); };

  const add = async () => {
    if (!deviceToAdd) return;
    try {
      reportResult(await addAllowedDevice({ employeeId, deviceId: deviceToAdd }), 'Device allowed');
      setDeviceToAdd(null); loadAllowed(employeeId);
    } catch (e) { message.error(e?.response?.data?.message || 'Failed'); }
  };

  const remove = async (deviceId) => {
    try {
      reportResult(await removeAllowedDevice({ employeeId, deviceId }), 'Device removed');
      loadAllowed(employeeId);
    } catch (e) { message.error(e?.response?.data?.message || 'Failed'); }
  };

  const columns = [
    { title: 'Code', render: (_, r) => r.deviceId?.deviceCode },
    { title: 'Name', render: (_, r) => r.deviceId?.deviceName },
    { title: 'OS', render: (_, r) => r.deviceId?.operatingSystem },
    {
      title: 'Actions', render: (_, r) => (
        <Popconfirm title="Remove this allowed device?" onConfirm={() => remove(r.deviceId?._id)}>
          <a>Remove</a>
        </Popconfirm>
      ),
    },
  ];

  return (
    <Card size="small">
      <Space direction="vertical" style={{ width: '100%' }} size="middle">
        <Select style={{ width: 360 }} placeholder="Select employee" showSearch optionFilterProp="label"
          value={employeeId} onChange={onSelectEmployee}
          options={users.map((u) => ({ label: `${u.name} (${u.employeeCode || u.email})`, value: u._id }))} />

        {employeeId && (
          <>
            <Space>
              <Select style={{ width: 360 }} placeholder="Add a registered device" showSearch optionFilterProp="label"
                value={deviceToAdd} onChange={setDeviceToAdd}
                options={devices.map((d) => ({ label: `${d.deviceName || d.deviceCode} (${d.deviceCode})`, value: d._id }))} />
              <Button type="primary" onClick={add} disabled={!deviceToAdd}>Add</Button>
            </Space>
            <Table rowKey="_id" columns={columns} dataSource={allowed} loading={loading} size="small" pagination={false} />
          </>
        )}
      </Space>
    </Card>
  );
};

export default DeviceAssignmentTab;
